import { useEffect } from 'react';

export function useKeyBinding({ keys, ref, callback, bothCases = true }, deps: string[] = []): any {
	if (!Array.isArray(keys)) keys = [keys];
	const onKeyPressed = e => {
		e.stopPropagation();
		for (let key of keys) {
			let targetKeyPressed = bothCases
				? e.key === key.toLowerCase() || e.key === key.toUpperCase()
				: e.key === key;
			if (targetKeyPressed) {
				callback(e);
				return;
			}
		}
	};

	useEffect(() => {
		if (!ref) return;
		ref.addEventListener('keydown', onKeyPressed);
		return () => ref.removeEventListener('keydown', onKeyPressed);
	}, deps);
}
